import { useCallback } from "react";
import apiClient2 from "../../api/apiClient2";

/**
 * Mirrors srcMobile/Screens/MagicBagPack/useRetrieveContent.tsx
 *   - getFetchMagicPackData(apiURL) → GET items for video/audio/image/book
 *   - updateMagicPackList(apiURL)   → PATCH to mark seen
 */
export function useMagicBackpack() {
  const fetchMagicPackData = useCallback(async (apiURL: string) => {
    try {
      const response = await apiClient2.get(apiURL);
      return response?.data;
    } catch (err: any) {
      console.error("fetchMagicPackData error:", err);
      return null;
    }
  }, []);

  const updateMagicPackSeen = useCallback(async (apiURL: string) => {
    try {
      const response = await apiClient2.patch(apiURL);
      return response?.data;
    } catch (err: any) {
      console.error("updateMagicPackSeen error:", err);
      return null;
    }
  }, []);

  return { fetchMagicPackData, updateMagicPackSeen };
}
